var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { krBaseCSS } from '../style/base.js';
/**
 * A tab for the kr-tab-group component.
 *
 * @element kr-tab
 * @slot - The tab panel content
 * @slot icon - Optional icon to display in the tab header
 */
export class KRTab extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Unique identifier for the tab
         */
        this.id = '';
        /**
         * Display label for the tab
         */
        this.label = '';
        /**
         * Badge text displayed next to label (e.g. notification count)
         */
        this.badge = '';
        /**
         * Badge background color
         */
        this.badgeBackground = '';
        /**
         * Badge text color
         */
        this.badgeColor = '';
        /**
         * Whether the tab is disabled
         */
        this.disabled = false;
        /**
         * Whether the tab can be dismissed/closed
         */
        this.dismissible = false;
        /**
         * Whether this tab is currently active (set by parent)
         */
        this.active = false;
    }
    updated() {
        // The parent kr-tab-group renders tab headers by reading properties from its
        // kr-tab children. When those properties change, tell the parent to re-render.
        const tabGroup = this.closest('kr-tab-group');
        if (tabGroup) {
            tabGroup.requestUpdate();
        }
    }
    /**
     * Gets the icon element from the icon slot (if any)
     */
    getIconElement() {
        return this.querySelector('[slot="icon"]');
    }
    render() {
        return html `<slot></slot>`;
    }
}
KRTab.styles = [
    krBaseCSS,
    css `
      :host {
        display: none;
      }

      :host([active]) {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
];
__decorate([
    property({
        type: String,
        reflect: true,
    })
], KRTab.prototype, "id", void 0);
__decorate([
    property({ type: String })
], KRTab.prototype, "label", void 0);
__decorate([
    property({ type: String })
], KRTab.prototype, "badge", void 0);
__decorate([
    property({
        type: String,
        attribute: 'badge-background',
    })
], KRTab.prototype, "badgeBackground", void 0);
__decorate([
    property({
        type: String,
        attribute: 'badge-color',
    })
], KRTab.prototype, "badgeColor", void 0);
__decorate([
    property({ type: Boolean })
], KRTab.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], KRTab.prototype, "dismissible", void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true,
    })
], KRTab.prototype, "active", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-tab')) {
    customElements.define('kr-tab', KRTab);
}
//# sourceMappingURL=tab.js.map